import { Form } from "antd";
import { useParams } from "react-router";

import { AppProfilePromptDataTable } from "src/app/features/ApplicationProfile/subFeatures/PromptData/components/tables/AppProfilePromptDataTable";
import type { FieldMethod } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const AppProfilePromptDataTableField: FieldMethod = ({ field }) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AppProfilePromptDataTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
